import {ImageModel} from "./ImageModel";

export interface StudioCommentsModel {
	comments: string;
	createdAt: string;
	updatedAt: string;
	id: string;
	accessId: {
		emailId?: string;
		firstName: string;
		lastName: string;
		role: string;
		image?: {
			USER_PROFILE: ImageModel;
			original: ImageModel;
		},
		title?: string;
		id: string;
	};
};
